import { render, staticRenderFns } from "./main-boards.vue?vue&type=template&id=162eae54&scoped=true&"
import script from "./main-boards.vue?vue&type=script&lang=js&"
export * from "./main-boards.vue?vue&type=script&lang=js&"
import style0 from "./main-boards.vue?vue&type=style&index=0&id=162eae54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162eae54",
  null
  
)

export default component.exports